import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    ButtonGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter
} from 'reactstrap';
import {
    reactSelectOption,
    reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import Select from 'react-select';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_AllServices } from '../../../../../constants/APIs';
import { RuleForm } from './RuleForm';
import { RuleActions } from './RuleActions';
import country from '../../../../../data/country';
import Languages from '../../../../../data/languages';
import NudgeList from '../../../../../data/NudgeList';

export function RuleList({ liveChatSetting, propertiesList, ruleDataList, integrationId, deleteRule, submit, questionOption }) {
    const [isEdit, setIsEdit] = useState(false);
    const [ruleId, setRuleId] = useState(undefined);
    const [isDeleteVisible, setIsDeleteVisible] = useState(false);
    const [updateData, setUpdateData] = useState([]);
    const [isActionVisible, setIsActionVisible] = useState(false);
    const [servicesList, setServicesList] = useState([]);
    const [servicesOfferDealList, setServicesOfferDealList] = useState([]);
    const [actionData, setActionData] = useState([]);

    useEffect(() => {
        if (propertiesList !== undefined) {
            let data = {
                languageCode: "en",
                propertyId: propertiesList
            };
            AxiosAPI({
                method: 'post',
                url: `${gAPI_AllServices}`,
                data: data
            })
                .then((res) => {
                    const serviceData = res.data.services.filter((item) => item.status === "Active");
                    setServicesList(serviceData);
                    let offers = serviceData.filter((item) => item.offerDiscount === true);
                    setServicesOfferDealList(offers);
                })
                .catch((err) => console.log('err', err));

        }
    }, [propertiesList]);
    const handleEdit = (id) => {
        setIsEdit(!isEdit);
        setRuleId(id);
        let data = ruleDataList.filter(i => i.id === id);
        setUpdateData(data);
    }
    const toggleDelete = () => {
        setIsDeleteVisible(!isDeleteVisible);
    }
    const handleDelete = (id) => {
        toggleDelete();
        let data = ruleDataList.filter(i => i.id !== id);
        setUpdateData(data);
    }
    const handleDeleteRule = () => {
        toggleDelete();
        deleteRule(updateData);
    };

    const generateDeletePopup = () => {
        return (
            <Fragment>
                <Modal isOpen={isDeleteVisible} toggle={toggleDelete}>
                    <ModalHeader toggle={toggleDelete}>
                        <span role="img" aria-label="warning">
                            ⚠️
                        </span>
                        This will be delete rule.
                    </ModalHeader>
                    <ModalBody>
                        <Button
                            color="danger"
                            onClick={() => handleDeleteRule()}
                            size="xs"
                        >
                            Delete
                        </Button>
                        <Button
                            className="ml-2"
                            color="dark"
                            outline
                            size="xs"
                            onClick={toggleDelete}
                        >
                            Cancel
                        </Button>
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    };
    const handleSubmit = (data) => {
        submit(data);
    }
    const handleActions = (id) => {
        let data = ruleDataList.filter(i => i.id === id);
        setUpdateData(data);
        setIsActionVisible(!isActionVisible);
    }
    const handleSubmitAction = (data) => {
        let body = {
            ...data[0],
            groupId: getGroupID(),
            integrationId: integrationId,
        }
        submit(body);
    };
    const calculateDuration = (val) => {
        return val / 1000;
    };
    return (
        <Fragment>
            {isActionVisible && (
                <RuleActions
                    liveChatSetting={liveChatSetting}
                    servicesList={servicesList}
                    servicesOfferDealList={servicesOfferDealList}
                    visible={isActionVisible}
                    toggle={() => {
                        setIsActionVisible(!isActionVisible);
                    }}
                    submit={handleSubmitAction}
                    updateData={updateData}
                ></RuleActions>
            )}
            {isEdit && (
                <RuleForm
                    visible={isEdit}
                    formLabel={"Update"}
                    toggle={() => {
                        setIsEdit(!isEdit);
                    }}
                    updatedData={updateData}
                    integrationId={integrationId}
                    submit={handleSubmit}
                    questionOption={questionOption}></RuleForm>
            )}
            {generateDeletePopup()}
            {ruleDataList !== null && ruleDataList.length > 0 ? (
                <Row>
                    <Colxx xxs="12">
                        <div className="equal-height-container mb-5 row">
                            {ruleDataList.map((rule, index) => (
                                <div key={index} className="col-item mb-4 col-md-12 col-lg-6">
                                    <div className="card">
                                        <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
                                            <div className="price-top-part">
                                                <h5 className="mb-0 font-weight-semibold color-theme-1 mb-1">{rule.ruleName}</h5>
                                            </div>
                                            <div className="pl-3 pr-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
                                                <ul className="list-unstyled">
                                                    {rule.condition.map((con, i) => (
                                                        <li key={i}>
                                                            {con.operator !== "" && " " + con.operator} {con.text}
                                                            {con.recommenderOptions && con.recommenderOptions.length > 0 && (
                                                                <p className="mb-0 text-muted">
                                                                    ({con.recommenderOptions.map((tag, index) => (
                                                                        <Fragment key={index}>
                                                                            {con.text === "Recommender choices made by the customer" &&
                                                                                questionOption.filter((i) => i.value === tag.id).map((item) => item.label)
                                                                            } {index < con.recommenderOptions.length - 1 && ","}
                                                                        </Fragment>
                                                                    ))})
                                                                </p>
                                                            )}
                                                            {con.tags && con.tags.length > 0 && (
                                                                <p className="mb-0 text-muted">
                                                                    ({con.tags.map((tag, index) => (
                                                                        <Fragment key={index}>
                                                                            {con.text === "Customer's preferred language" ?
                                                                                Languages.filter((i) => i.code.includes(tag)).map((item) => item.name) :
                                                                                con.text === "Customer's country" ?
                                                                                    country.filter((i) => i.code.includes(tag)).map((item) => item.name) :
                                                                                    tag} {index < con.tags.length - 1 && ","}
                                                                        </Fragment>
                                                                    ))})
                                                                </p>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                                {rule.action && rule.action.length > 0 && (
                                                    <Fragment>
                                                        <p className="text-center mb-2"><strong>ACTIONS</strong></p>
                                                        <Row>
                                                            {rule.action.map((act, i) => (
                                                                <Colxx sm={12} key={i} className="mb-2">
                                                                    <Card>
                                                                        <div style={{ padding: "10px", marginTop: "0px" }}>
                                                                            <div>
                                                                                <p className="color-theme-1 mb-1">{act.nudge}</p>
                                                                                <div className="mb-0 label text-small">
                                                                                    {act.nudge === "Promote Product Service or Activity" ||
                                                                                        act.nudge === "Offer Package or a Deal" ?
                                                                                        act.service && act.service.length > 0 && (
                                                                                            <ul className="list-unstyled">
                                                                                                {act.service.map((serv, i) => (<li key={i}>{serv.title}</li>))}
                                                                                            </ul>
                                                                                        ) : act.nudge === "Assign Customer Segment" ?
                                                                                            act.suitability && act.suitability.length > 0 && (
                                                                                                <ul className="list-unstyled">
                                                                                                    {act.suitability.map((serv, i) => (<li key={i}>{serv}</li>))}
                                                                                                </ul>
                                                                                            ) :
                                                                                            act.nudge === "Nudge with a text message" ?
                                                                                                act.nudgeButton && (
                                                                                                    <div>{act.text} <br />
                                                                                                        <b>Delay in Seconds : </b>
                                                                                                        {act.nudgeButton.delayInMilliseconds ?
                                                                                                            calculateDuration(act.nudgeButton.delayInMilliseconds)
                                                                                                            : null}s
                                                                                                        <br />
                                                                                                        {act.nudgeButton.buttons && act.nudgeButton.buttons.map((item, i) =>
                                                                                                            <span key={i} className="mb-1 badge badge-outline-primary badge-pill">{item.text}</span>)}
                                                                                                    </div>
                                                                                                ) : act.text}

                                                                                    {act.value !== "" && (<Fragment> : {act.value}</Fragment>)}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Card>
                                                                </Colxx>
                                                            ))}
                                                        </Row>
                                                    </Fragment>
                                                )}
                                                <div className="text-center">
                                                    <ButtonGroup className="mb-2">
                                                        <Button
                                                            size="xs"
                                                            color="success"
                                                            outline
                                                            onClick={() => handleEdit(rule.id)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            size="xs"
                                                            color="danger"
                                                            outline
                                                            onClick={() => handleDelete(rule.id)}
                                                        >
                                                            Delete
                                                        </Button>
                                                        <Button
                                                            size="xs"
                                                            color="danger"
                                                            outline
                                                            onClick={() => handleActions(rule.id)}
                                                        >
                                                            + Actions
                                                        </Button>
                                                    </ButtonGroup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Colxx>
                </Row>) : (
                <Row>
                    <Colxx xxs="12">
                        <p>No rules found</p>
                    </Colxx>
                </Row>
            )}
        </Fragment >)
};